import React from 'react';
import { useTranslation } from 'react-i18next';
import camelCase from 'lodash/camelCase';
import { useRouteQuery } from 'src/common/helpers';
import { PageTopbar } from 'src/components/employee/page-topbar';
import {
  EMPTY_ILLUSTRATIONS,
  EmptyContainer,
  Loader,
  PLATFORM_THEME_COLORS,
  Typography,
} from '@thinknet-gmbh/platform-common-ui';

import { useGetWagesAndSalary } from 'src/hooks/wages-and-salary/get-all-wages-and-salary.hook';

import { dateFormat } from 'src/common/helpers/date.helpers';
import { currencyFormatter, generateReactKey } from 'src/common/helpers/common.helpers';

import { ElementContainer, MainWrapper } from './wages-and-salary-view.styles';
import { InfoElement, InfoBlock } from 'src/components/employee/employee-common.styles';

import { IWageAndSalaryItem } from '../wages-and-salary.interfaces';
import isEmpty from 'lodash/isEmpty';

const WagesAndSalaryView = ({ onClickEdit }: { onClickEdit: () => void }) => {
  const { t } = useTranslation(['employee', 'common']);

  const query = useRouteQuery();
  const _id: string = query.get('id') || '';

  const { collection, loading } = useGetWagesAndSalary({
    memberId: _id,
  });

  if (loading) {
    return <Loader />;
  }

  return (
    <MainWrapper>
      <PageTopbar
        pageTitle={t('employee:wagesAndSalary.labels.wagesAndSalary')}
        onClickEdit={onClickEdit}
      />
      {isEmpty(collection) ? (
        <EmptyContainer
          emptyTitle={t('common:emptyContainer.emptyTitle')}
          contentText={t('common:emptyContainer.contentText')}
          illustration={EMPTY_ILLUSTRATIONS.dataAnalysis}
        />
      ) : (
        <ElementContainer>
          {collection.map(({ salaryType, startDate, amount }: IWageAndSalaryItem) => {
            return (
              <InfoBlock key={generateReactKey()} columns={'1fr 1fr 1fr'}>
                <InfoElement>
                  <Typography weight="bold">{`${t(`employee:labels.salaryType`)}`}</Typography>
                  <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
                    {salaryType
                      ? t(`employee:workingConditions.labels.${camelCase(salaryType)}`)
                      : '-'}
                  </Typography>
                </InfoElement>
                <InfoElement>
                  <Typography weight="bold">{`${t(`employee:labels.salaryStartDate`)}`}</Typography>
                  <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
                    {startDate ? dateFormat(startDate) : '-'}
                  </Typography>
                </InfoElement>

                <InfoElement>
                  <Typography weight="bold">{`${t(`employee:labels.salaryAmount`)}`}</Typography>
                  <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
                    {amount ? currencyFormatter(amount) : '-'}
                  </Typography>
                </InfoElement>
              </InfoBlock>
            );
          })}
        </ElementContainer>
      )}
    </MainWrapper>
  );
};

export default WagesAndSalaryView;
